import { Box, Typography } from "@mui/material";
import { StyledCompanyInfoCard } from "./CompanyInfoCard.styled";
import { useContext } from "react";
import { DocumentContext } from "../../globals/LanguageContext";
import { companyInfo } from "../../globals/constants";

type CompanyInfoCardProps = {
  title: string;
};

export const CompanyInfoCard = ({ title }: CompanyInfoCardProps) => {
  const { documentDictionary } = useContext(DocumentContext);

  return (
    <StyledCompanyInfoCard>
      <Typography variant="h1">{title}</Typography>
      <Box className="row" />
      <Box className="row">
        <Typography variant="h4">{companyInfo.name}</Typography>
      </Box>
      <Box className="row">
        <Typography variant="h4">{companyInfo.address}</Typography>
      </Box>
      <Box className="row">
        <Typography variant="h4">{companyInfo.city}</Typography>
      </Box>
      <Box className="row">
        <Typography variant="h4">{companyInfo.country}</Typography>
      </Box>
      <Box className="row" />
      <Box className="row">
        <Typography variant="h4" className="text">
          {documentDictionary.companyInfo.companyNumber}
        </Typography>
        <Typography variant="h4">{companyInfo.vat}</Typography>
      </Box>
      <Box className="row">
        <Typography variant="h4" className="text">
          {documentDictionary.companyInfo.email}
        </Typography>
        <Typography variant="h4">{companyInfo.email}</Typography>
      </Box>
      <Box className="row">
        <Typography variant="h4" className="text">
          {documentDictionary.companyInfo.phone}
        </Typography>
        <Typography variant="h4">{companyInfo.phone}</Typography>
      </Box>
      <Box className="row" />
    </StyledCompanyInfoCard>
  );
};
